import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { BsButton } from '../../collection/bootstrap/BootstrapComponents';
import DataTable from '../../collection/DataTable';
import BoolIcon from '../../collection/icons/Boolean';
import TableHandler from '../../collection/TableHandler';
import PrendaModal from '../../components/modals/PrendaModal';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import { apiDelete, apiForm } from '../../utils/api';
import { sortableString, generateFormData } from '../../utils/functions';
import PrendasFilter from '../../components/filters/PrendasFilter';

export default function Prendas(props) {
    // filter
    const defaultFilter = {
        nombre: null,
        gruposTallas: null,
        epi: false
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("prendas/table", filter);
    };
    const deleteRow = async id => await apiDelete("prendas/delete/" + id);

    // render
    return <>
        <h2>Prendas</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            elementText="la prenda">
            <PrendasFilter
                className="my-3" fem
                defaultValue={defaultFilter} />
            <PrendasTable />
        </TableHandler>
    </>;
}

function PrendasTable(props) {
    // table columns
    const columns = [
        {
            name: "Nombre",
            selector: row => sortableString(row.Name),
            format: row => row.Name,
            sortable: true
        },
        {
            name: "Grupo Tallas",
            selector: row => sortableString(row.NameGrupoTallas),
            format: row => row.NameGrupoTallas,
            sortable: true
        },
        {
            name: "EPI",
            selector: row => row.EPI,
            format: row => <BoolIcon value={row.EPI} size="lg" />,
            sortable: true,
            center: true,
            width: "8%"
        }
    ];
    // table buttons
    const buttons = <>
        <BsButton variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></BsButton>
        <BsButton variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></BsButton>
    </>;

    // render
    return <>
        <DataTable responsive columns={columns} data={props.data} buttons={buttons} pagination defaultSortFieldId={1} />
        {props.formOpen && (
            <PrendaModal
                show={props.formOpen}
                onHide={props.onFormClose}
                idPrenda={props.formId}
            />
        )}
        <FloatingAddButton onClick={props.onNew} />
    </>;
}
